import { ID } from '@models';
import { components, paths } from '@api/api';
import useAxios from "@hooks/useFetch";

const ENDPOINT: keyof paths = '/RestaurantList/{countryCode}/{restaurantListId}';
type Response = components['schemas']['BaseModel'][];

export type AllRestaurants = Response;

export default function useRestaurants(countryCode: ID, restaurantListId: number) {
    return useAxios<Response>({
        url: ENDPOINT
            .replace('{countryCode}', `${countryCode}`)
            .replace('{restaurantListId}', restaurantListId.toString()),
        method: 'get',
        lazy: !countryCode || restaurantListId === 0,
    });
}